<template>
  <div class="page checkout">

    <div class="onlyForHighScreens">&nbsp;</div>

    <v-container>
      <h1 class="text-center mt-3" style="margin-bottom: 2px;">
        <span>Bestellung aufgeben</span>
      </h1>
    </v-container>
    <div class="text-center">

      <h4 class="mb-6">Gesamtsumme:
        <span class="textFont">{{ total | priceTotal }}</span>
      </h4>

      <!--      <h4 class="mb-6">-->
      <!--        Direkte Bezahlung am Terminal-->
      <!--      </h4>-->

    </div>

    <v-container class="ccontainer" grid-list-md>
      <!--        <v-container class="bigger-input" grid-list-md>-->

      <div class="kioskCheckoutContainer">
        <v-stepper v-model="currentStep" vertical class="vvd orderform" id="stepper">

          <v-stepper-step :complete="currentStep > 1" step="1" @click.native.passive="currentStep = 1">
            <div class="nice-title titleFont">Optional kannst du deinen Namen für die Abholung eingeben</div>
            <!--                    <div class="nice-title small">Bitte überprüfe deine Daten</div>-->
          </v-stepper-step>
          <v-stepper-content step="1">
            <!--                    <div v-if="!hasFd" class="hinweis">-->
            <!--                        &lt;!&ndash;                        <v-icon>mdi-information-variant</v-icon>&ndash;&gt;-->
            <!--                        <div>Deine Eingabe wird lokal gespeichert, um zukünftige Bestellungen zu erleichtern 👍</div>-->
            <!--                    </div>-->
            <!--                    <h4 class="mb-1" v-if="asGuest">Bestellung als Gast</h4>-->
            <div v-if="usecase.length > 0" id="checkData">
              <!--                        <h4>Überprüfe deine Daten&nbsp;&nbsp;<v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                        </v-icon>-->
              <!--                        </h4>-->
              <div class="bestelldaten pt-1">
                <v-form v-show="showForm" @submit.prevent="" ref="inhouseMpDataForm" v-model="valid" lazy-validation>
                  <div class="prelative">
                    <v-text-field
                      outlined
                      :value="name" @input="updateName"
                      label="Dein Name"
                      :rules="nameRules"
                      placeholder="Dein Name"
                      illed hide-details
                      @focus="nameFocus"
                      @blur="unhideToolbar"
                    ></v-text-field>
                    <div v-if="name" class="absClear">
                      <v-icon class="myBlack" @click.passive.stop="name=''"
                      >mdi-close
                      </v-icon>
                    </div>
                  </div>

                  <template v-if="$store.state.enableOrderNote">
                    <h4 class="mt-4">Hinweise zur Bestellung</h4>
                    <v-text-field
                      outlined
                      hide-details
                      v-model="note"
                      class="nolabel"
                      clearable
                      illed
                      @focus="hinweisFocus"
                    ></v-text-field>
                  </template>

                </v-form>
              </div>


            </div>


            <!--                <v-btn color="primary" @click="currentStep = 2">Continue</v-btn>-->
          </v-stepper-content>
        </v-stepper>
      </div>

      <div class="mt-4 text-center">
        <div>
          <v-btn class="mt-3 orderBtn wallet-width text-none rounded100"
                 color="green"
                 dark
                 @click.native.passive="finishStep1">
            Bestätige deine Bestellung
          </v-btn>
        </div>
      </div>


    </v-container>

    <div class="text-center">
      <!--      <v-btn style="margin-top: 25px" class="text-none btn-df"-->
      <!--             @click.native.passive="gotoSummary">-->
      <!--        Zurück zum Korb-->
      <!--      </v-btn>-->
      <div class="spacer-25"></div>
      <v-btn style="margin-top: 25px" class="text-none btn-mini" @click="cancelOrder">
        Bestellung abbrechen
      </v-btn>
    </div>

    <!--        <times-info-dialog :dialog="timesInfoDialog" @close="timesInfoDialog = false"></times-info-dialog>-->

    <div class="spacer-25"></div>

    <!--        <qsignal class="hide-md"></qsignal>-->


    <ZvtDialog
      :total="total"
      :terminalInstructions="terminalInstructions"
      :dialog="showZvtDialog" @close="closeZvtDialog"></ZvtDialog>

    <div v-if="showKeyboard" class="fixedVirtualKeyboard">
      <div class="superCenter">
        <VirtualKeyboard
          :label="keyboardLabel"
          @enter="keyboardEnter"
          @close="showKeyboard = false"
        ></VirtualKeyboard>
      </div>
    </div>

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as bootstrap from '../vendor/bootstrap';
import * as xhr from '../api/xhr.js'
// import * as iframe from "../iframe/iframe";
import * as util from '../vendor/util'
import {clearTheInterval, clearTheTimeout, cloneMe, isEmptyObject} from '../vendor/util'
import * as checkoutUtil from '../util/inhouseMPUtil'
// import* as plausi from '../vendor/plausi'
import * as qconst from '../vendor/qconstants';
import {enableGoodpay, enablePaypal, kioskResetTimeoutAfterOrder, PROD_ENV} from '../vendor/qconstants';

// TODO activate for online
import * as firebaseUtil from '@/firebase/firebaseUtil'
// import* as paypalUtil from '../paypal/paypalUtil'
import Orderconsent from "../components/orderconsent";

// import Qsignal from "../components/qsignal";
import SslSeal from "../components/sslSeal";
import {removeGlobalKey, setGlobalKeyValue} from "@/util/globalState";
import {getName1Error, isEmailOk, isIos, isMobileOk, roundToTwo} from "@/vendor/util";
import {appleCanMakePayments} from "@/goodpay/applePay/apple-pay-js-handler";
import AcceptAgbsText from "@/components/AcceptAgbsText.vue";
import {getErrorDetails} from "@/util/globalErrorHandler";
import ZvtDialog from "../dialogs/ZvtDialog.vue";
import VirtualKeyboard from "./VirtualKeyboard.vue";
// import* as breakpoints from '../vendor/breakpoints'

// import TimesInfoDialog from "../dialogs/TimesInfoDialog";

let recaptchaScript = null;

export default {
  components: {
    VirtualKeyboard,
    ZvtDialog,
    AcceptAgbsText,
    Orderconsent,
    SslSeal
  },

  data() {
    return {
      showKeyboard: false,
      keyboardLabel: '',
      showZvtDialog: false,
      terminalInstructions: '',
      zvtTimeoutId: null,
      ivZvt: null,
      waitingForZvtFreitext: '',
      enableGoodpay: enableGoodpay,
      accceptedAgbs: false,
      valid: true,
      showForm: true,
      fromCheckout: false,
      showSubmitButton: true,
      initialTry: false,
      clientId: '',
      fastUnload: false,
      simulateTransportError: false,
      updateInterval: null,
      isInvoiceAddressVisible: false,

      plannedAnkunftszeit: this.$ls.get('userSelectedTargetTime'),

      hasFd: true,

      //captcha
      captchaInput: '',
      // numberRule: v  => {
      //     if (!v.trim()) return true;
      //     if (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999) return true;
      //     return 'Number has to be between 0 and 9999';
      // },

      //abholung öffnungszeiten
      abholDatumArray: [
        {value: 'Heute'},
        {value: 'Morgen'}
      ],
      selectedAbholDatum: {value: 'Heute'},//default
      time: null, //{value:'06:45', utc:...}//produces a string i.e. 06:45
      timesToday: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],
      timesTomorrow: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],

      //Formulardaten
      name: '',
      nameRules: [
        v => !v || !getName1Error(v) || 'Bitte Namen eingeben',
        // v => (!v && !this.selfServiceEnabled) || !getName2Error(v) || 'Bitte vollständigen Namen eingeben',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-Mail ist erforderlich',
        v => isEmailOk(v) || 'Ungültige E-Mail',
      ],
      phone: '',
      phoneRules: [
        v => (!v && !this.selfServiceEnabled) || !!v || 'Die Mobilnummer wird benötigt',
        // v => /^(?=.*\d)[\d ]+$/.test(v) || 'Dieses Feld darf nur Nummern oder Leerzeichen enthalten',
        v => (!v && !this.selfServiceEnabled) || isMobileOk(v) || 'Die Mobilnummer ist zu kurz'
      ],
      // vorname: '',
      // nachname: '',
      sameAsInvoiceAddress: true,
      invoiceAddress: {
        company: '',
        street: '',
        plz: '',
        city: '',
      },
      deliveryAddress: {
        company: '',
        street: '',
        plz: '',
        city: '',
        etage: '',
      },

      step1Error: '',

      note: '',


      // autoModel: null,
      // {
      //     displayName: '345567 Straße, Maxdorf',
      //         obj: storeObject
      // }

      // selectedStore: {
      //     // plz:'',
      //     // strasse:'',
      //     //   openingHours:
      // },
      // stores: [],
      consent: false,

      showBar: false,
      showGoodpayCc: enableGoodpay,
      showGoodpayGoogleWallet: false,
      showGoodpayAppleWallet: false,
      showPaypal: true,

      hasPR: false,
      wait: false,
      total: 0,

      // earlyPaymentIntentId: '',
      // earlyClientSecret: '',

      // deliveryFee: 0,
      // fee: 0,
      // minOrderAmount: 0,

      currentStep: 1,
      usecase: qconst.usecase$tableOrdering,//initial value 'delivery',
      // daySelected: 'asap',

      // time: null, //{value:'06:45'}//produces a string i.e. 06:45
      // times: [
      //     //{ value : '06:45'}
      // ],

      // internalDaySelected: '1',

      psp: '', //none, waiter, bar, credit, paypal

      // consentA: false,
      // consentB: false,

      // deliveryAddress: {
      //     // company: '',
      //     street: '',
      //     plz: '',
      //     city: '',
      //     etage: '',
      // },

      order: {},

      unloadTargetTime: 0,

      //Goodpay Common
      goodpayScriptCreated: false,
      //Goodpay Credit
      goodpayCreditTransaction: null,
      goodpayTxIsForAliasId: '',
      goodpayTxToken: '',
      goodpayCreditAuthData: null,
      goodpayExpireAt: 0,
      gpFieldsToken: '',
      showCreditForm: true,
      selectedAliasId: '',
      //Google Wallet
      goodpayHasPaymentRequest: true,
      googlePayResponse: null,
      //Apple Wallet
      canMakePayments: false,
      applePayResponse: null,
      //Goodpay Common Wallet Data
      goodpayWalletExpireAt: 0,
      goodpayWalletAuthData: null,
      goodpayWalletTransaction: null,
      goodpayWalletTxToken: '',

      //paypal
      paypalOrderId: null,
      // paypalPreAuth: {},

      // paymentIntentAmount: -1,
      paymentIntentStatus: '',
      orderNumber: '',
      uniqueOrderId: '',

      //only calculated:
      pickupDate: {},
      // displayPickupDate: '',

      // timesInfoDialog: false,
      timesInfoDialog: false,
    }
  },

  watch: {

    time(newValue) {
      if (newValue && newValue.utc) {
        this.$ls.set('selectedTime', newValue);
        //         store.commit('selectedTime', util.cloneMe(newValue));
      }
    }

  },

  computed: {
    totalSavedByDiscounts() {
      return roundToTwo(store.getters.appliedDiscounts.reduce((sum, d) => sum + d.absoluteAmount, 0));
    },
    showCustomerCard() {
      // try {
      //   return store.getters.bbnUser.primaryCardId.length > 0
      //     && !!store.getters.cards.find(c => c.rfid === store.getters.bbnUser.primaryCardId)
      //       .accounts.find(a => a.accountType === 'CRED');
      // } catch (e) {
      return false;
      // }
    },
    step1Ok() {
      // if (this.selfServiceEnabled) {
      //   let nameError = util.getName1Error(this.name);
      //   if (nameError) {
      //     this.step1Error = nameError
      //     return false;
      //   }
      // }

      // if (this.name.length < 4 || this.name.indexOf(' ') < 2) {
      //     this.step1Error = 'Bitte Vor- und Nachname eingeben';
      //     return false;
      //     // } else {
      //     //     let nn = this.name.substring(this.name.indexOf(' ') + 1, this.name.length);
      //     //     if (nn.length < 2) {
      //     //         this.step1Error = 'Bitte Vor- und Nachname eingeben';
      //     //         return false;
      //     //     }
      // }

      // if (this.selfServiceEnabled && !this.checkMobilnummer()) {
      //   this.step1Error = 'Die eingegebene Mobilnummer ist ungültig';
      //   return false;
      // }

      // //InvoiceAddress
      // //street
      // if (this.invoiceAddress.street.length < 4) {
      //     this.step1Error = 'Die Straße ist erforderlich';
      //     return false;
      // }
      //
      // if (this.invoiceAddress.street.length > 0 && (/\d/.test(this.invoiceAddress.street) === false)) {
      //     this.step1Error = 'Die Hausnummer fehlt';
      //     return false;
      // }
      //
      // //validate plz
      // if (this.invoiceAddress.plz.length < 4) {
      //     this.step1Error = 'Die Postleitzahl ist erforderlich';
      //     return false;
      // }
      // let plz = util.removeSpaces(this.invoiceAddress.plz);
      // if (isPlzOk(plz) === false) {
      //     this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
      //     return false;
      // }
      // if (plz.length < 4) {
      //     this.step1Error = 'Die Postleitzahl ist zu kurz';
      //     return false;
      // }
      //
      // //city
      // if (this.invoiceAddress.city.length < 3) {
      //     this.step1Error = 'Der Ort ist erforderlich';
      //     return false;
      // }

      // if (!this.sameAsInvoiceAddress) {
      //     //deliveryAddress
      //     if (this.deliveryAddress.street.length < 4) {
      //         this.step1Error = 'Die Straße ist erforderlich';
      //         return false;
      //     }
      //
      //     if (this.deliveryAddress.street.length > 0 && (/\d/.test(this.deliveryAddress.street) === false)) {
      //         this.step1Error = 'Die Hausnummer fehlt';
      //         return false;
      //     }
      //
      //     //validate plz
      //     if (this.deliveryAddress.plz.length < 4) {
      //         this.step1Error = 'Die Postleitzahl ist erforderlich';
      //         return false;
      //     }
      //     let plz = this.deliveryAddress.plz.trim();
      //     if (isPlzOk(plz) === false) {
      //         this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
      //         return false;
      //     }
      //     if (plz.length < 4) {
      //         this.step1Error = 'Die Postleitzahl ist zu kurz';
      //         return false;
      //     }
      //
      //     //city
      //     if (this.deliveryAddress.city.length < 3) {
      //         this.step1Error = 'Der Ort ist erforderlich';
      //         return false;
      //     }
      // }
      this.step1Error = '';
      return true;
    },
    abholadresse() {
      return '';
      // return this.$options.filters.displayFiliale(store.getters.selectedStore);
    },
    asGuest() {
      return store.getters.loggedIn === false;
    },

    selfServiceEnabled() {
      return this.$store.getters.selfServiceEnabled;
    },

    // displayTomorrow() {
    //     let tomorrow = util.addDays(util.getCurrentRemoteTime(), 1);
    //     return this.$options.filters.weekDayMonth(tomorrow.getTime(), true);
    //
    //     // let d = tomorrow.toLocaleString();
    //     // return d.substring(0, d.indexOf(','));
    // },

    userSelectedHeute() {
      return this.selectedAbholDatum.value === 'Heute';
    },


  },

  beforeMount() {
    if (!this.checkEnter()) {
      return;
    }
    checkoutUtil.reset();
    let theTotal = this.$ls.get('theTotal');
    if (theTotal) {
      this.paymentRequestTotal = theTotal;
    }
    this.updateTotal();

    let itemsString = JSON.stringify(store.getters.cartItems);
    try {
      let itemsHash = new Hashes.SHA256().hex(itemsString);
      if (itemsHash === this.$ls.get('lastItemsHash')) {
        console.log('use the same clientId');
        // this.$ls.set('clientId', util.generateClientId());
      } else {
        console.log('generate a new clientId');
        this.$ls.set('lastItemsHash', itemsHash);
        this.$ls.set('clientId', util.generateClientId());
      }
    } catch (e) {
    }
  },

  activated() {
    this.init('activated');
  },

  created() {

    ebus.$on('cb-postToWindowskiosk', (resp) => {
      if (resp && !isEmptyObject(resp)) {
        const responseAction = '' + resp.action;
        delete resp.action;

        console.log('cb-postToWindowskiosk received for action ' + responseAction);

        if (responseAction === 'triggerPosTerminal') {
          if (store.getters.isAndroidKiosk) {
            //dummy delay for payment response
            // setTimeout(() => {
            this.handleAndroidPaymentResponseData(resp)
            // }, 3 * 1000);
          } else if (resp.paymentResponseData?.zvtOk) {
            console.log('zvtOk=true => directly handle zvtOk');
            this.handleZvtErgebnisResponse(resp.paymentResponseData)
          } else {
            console.log('zvtOk=false => try to getZvtErgebnis again');
            this.getZvtErgebnis(1);
          }
        } else if (responseAction === 'readStatusFromTerminal') {
          if (store.getters.isAndroidKiosk) {
            this.handleAndroidPaymentResponseData(resp)
          } else {
            this.handleZvtStatusResponse(resp);
          }
        } else if (responseAction === 'readErgebnisFromTerminal') {
          this.handleZvtErgebnisResponse(resp);
        } else if (responseAction === 'readAllParams') {
        } else if (responseAction === 'checkTerminalServiceActive') {
          if (!(resp.ok && resp.configSetupCompleted)) {
            ebus.$emit('showInfo', {
              title: 'WARNING: The device setup is incomplete. Please contact the administrator',
            });
            this.$router.replace({name: 'Home'});
          }
        }
      }
    });

    ebus.$on('appconfigLoaded', () => {
      // if (this.timesToday.length === 0) {
      this.init('appconfigLoaded');
      // }
    });
  },

  mounted() {
    this.checkTerminalOrFail();
    this.preInit();

    // appleCanMakePayments().then((can) => {
    //   console.log('appleCanMakePayments response can = ' + (!!can));
    //   this.$nextTick(() => {
    //     this.canMakePayments = !!can || !PROD_ENV;
    //   });
    // });

    this.$nextTick(() => {

      if (!bootstrap.getBtaste()) {
        window.location.reload();
        return;
      }

      if (this.asGuest && this.$store.getters.enableStempel) {
        ebus.$emit('toast', 'Bitte melde dich an, um Punkte für deine Stempelkarte zu sammeln');
      }

      // this.initDefaultDatePicker();
      // this.updateAllowedTimes();

      if (this.$ls.get('continueCheckout')) {
        let t = this.$ls.get('selectedTime');
        if (t) {
          this.time = util.cloneMe(t);
        }
      }

      ebus.$emit('loadAppconfig');
      store.state.hideScroll = true;
      this.captchaInput = '';
      // store.commit('showLoading', false);

      this.updateInterval = setInterval(() => {
        ebus.$emit('loadAppconfig');
      }, 30 * 1000);

      //only for online payment
      if (this.$ls.get('continueCheckout', false)) {
        this.$ls.remove('continueCheckout');
        // this.finishStep1();
        // if (this.time !== null) {
        //     let ea = this.calcEarliestAbholung();
        //     if (this.time.utc >= ea.getTime()) {
        //         //already selected time is till valid, so lets go to payment directly
        setTimeout(() => {
          this.psp = 'credit';
          this.finishStep1();
        }, 200);
        // } else {
        //     this.time = null;
        // }
        // }
      }
    });
  },

  destroyed() {
    this.safeUnload();
    checkoutUtil.reset();

    clearTheInterval(this.ivZvt);
    clearTheTimeout(this.zvtTimeoutId);

    util.clearEvents([
      'cb-postToWindowskiosk',
      'appconfigLoaded',
    ]);

    store.commit('removeSpecialCartItem', 'specialUniqueOnlineServiceFee');

    try {
      document.head.removeChild(recaptchaScript);
    } catch (e) {

    }

    store.state.hideScroll = false;
    // this.earlyClientSecret = '';
    this.clientSecret = '';
    this.order = {};
    this.usingPaymentRequest = false;
    this.paymentIntentId = '';
    // this.creditPreAuth = {};
    // this.paypalPreAuth = {};
    // document.getElementById('paypal-button-container').innerHTML = '';
    this.currentStep = 1;

    // this.paymentRequestCreated = false;

    util.clearTheInterval(this.updateInterval);

  },

  methods: {
    keyboardEnter(text) {
      if (this.keyboardLabel === 'Dein Name') {
        this.name = text;
      } else if (this.keyboardLabel === 'Hinweise zur Bestellung') {
        this.note = text;
      }
      this.showKeyboard = false;
    },
    nameFocus() {
      console.log('nameFocus');
      this.keyboardLabel = 'Dein Name';
      this.showKeyboard = true;
      this.hideToolbar();
    },
    hinweisFocus() {
      console.log('nameFocus');
      this.keyboardLabel = 'Hinweise zur Bestellung';
      this.showKeyboard = true;
      this.hideToolbar();
    },

    closeZvtDialog() {
      console.log('closeZvtDialog...');
      clearTheInterval(this.ivZvt);
      clearTheTimeout(this.zvtTimeoutId);
      this.showZvtDialog = false;
      store.commit('showLoading', false);
    },

    cancelOrder() {
      clearTheInterval(this.iv1);
      window.history.back();
      // this.$router.go(-1);
    },

    initIvZvt() {
      if (this.ivZvt) {
        clearTheInterval(this.iv1);
      }
      this.ivZvt = setInterval(() => {
        this.getZvtStatus();
      }, 400);
    },

    getZvtStatus() {
      ebus.$emit('postToWindowskiosk', {
        action: 'readStatusFromTerminal',
        orderId: '' + this.order.orderId,
        uniqueOrderId: this.order.uniqueOrderId,
        //terminalId: '' + store.getters.table,
        cb: 'cb-postToWindowskiosk'
      });
    },

    getZvtErgebnis() {
      ebus.$emit('postToWindowskiosk', {
        action: 'readErgebnisFromTerminal',
        //terminalId: '' + store.getters.table,
        cb: 'cb-postToWindowskiosk'
      });
    },

    handleZvtStatusResponse(resp) {
      const ausgabe = resp.ausgabe;
      if (ausgabe?.Text) {
        this.terminalInstructions = ausgabe.Text;
      }
    },

    handleAndroidPaymentResponseData(resp) {
      if (resp.paymentTxEnded || this.paymentTxEnded) {
        this.paymentTxEnded = true;
        clearTheInterval(this.ivZvt);
      }

      const paymentResult = JSON.parse(resp.paymentResult || {});

      if (resp.paymentTxEnded) {
        console.log('final paymentResult: ' + resp.paymentResult, paymentResult);
        const receipt = '' + paymentResult.receipt;
        delete paymentResult.receipt;

        if (paymentResult.ok) {
          delete paymentResult.ok;
          this.markZvtPaymentCompleted(this, store, paymentResult, receipt);
        } else {
          this.closeZvtDialog();
          ebus.$emit('showInfo', {
            title: 'Fehler beim Zahlungsvorgang',
            text: paymentResult?.failureCode != null ? ('Fehlercode ' + paymentResult.failureCode) : ''
          });
        }
      }

      //FIXME TODO similar to handleZvtErgebnisResponse

      // if (this.waitingForZvtFreitext && ausgabe?.Freitext && ausgabe.Freitext === this.waitingForZvtFreitext) {
      //   this.waitingForZvtFreitext = '';
      //   // clearTheInterval(this.ivZvt);
      //
      //   if (ausgabe.Ergebnis === '0') {
      //     this.markZvtPaymentCompleted(this, store, ausgabe.ErgebnisLang, ausgabe.Drucktext2);
      //     // const betrag = roundToTwo(parseFloat(ausgabe.Betrag) / 100);
      //     // const displayBetrag = this.$options.filters.priceTotal(betrag);
      //     // ebus.$emit('showInfo', {
      //     //   title: 'Zahlung erfolgreich abgeschlossen',
      //     //   text: displayBetrag
      //     // });
      //   } else {
      //     this.closeZvtDialog();
      //     if (ausgabe?.Ergebnistext && !ausgabe.Ergebnistext.toLowerCase().includes('timeout')) {
      //       ebus.$emit('showInfo', {
      //         title: 'Fehler beim Zahlungsvorgang',
      //         text: ausgabe.Ergebnistext
      //       });
      //     }
      //   }
      // } else {
      //   this.closeZvtDialog();
      //   ebus.$emit('showInfo', {
      //     title: 'Unerwarteter Abbruch der Zahlung',
      //     text: ''
      //   });
      // }
    },

    handleZvtErgebnisResponse(resp) {
      const ausgabe = resp.ausgabe;
      clearTheInterval(this.ivZvt);

      if (this.waitingForZvtFreitext && ausgabe?.Freitext && ausgabe.Freitext === this.waitingForZvtFreitext) {
        this.waitingForZvtFreitext = '';
        // clearTheInterval(this.ivZvt);

        if (ausgabe.Ergebnis === '0') {
          this.markZvtPaymentCompleted(this, store, ausgabe.ErgebnisLang, ausgabe.Drucktext2);
          // const betrag = roundToTwo(parseFloat(ausgabe.Betrag) / 100);
          // const displayBetrag = this.$options.filters.priceTotal(betrag);
          // ebus.$emit('showInfo', {
          //   title: 'Zahlung erfolgreich abgeschlossen',
          //   text: displayBetrag
          // });
        } else {
          this.closeZvtDialog();
          if (ausgabe?.Ergebnistext && !ausgabe.Ergebnistext.toLowerCase().includes('timeout')) {
            ebus.$emit('showInfo', {
              title: 'Fehler beim Zahlungsvorgang',
              text: ausgabe.Ergebnistext
            });
          }
        }
      } else {
        this.closeZvtDialog();
        ebus.$emit('showInfo', {
          title: 'Unerwarteter Abbruch der Zahlung',
          text: ''
        });
      }
    },

    checkTerminalOrFail() {
      ebus.$emit('postToWindowskiosk', {
        action: 'checkTerminalServiceActive',
        cb: 'cb-postToWindowskiosk'
      });
    },

    refreshForm() {
      if (isIos()) {
        this.showForm = false;
        setTimeout(() => {
          this.showForm = true;
        }, 400);
      }
    },
    resetValidation() {
      this.$nextTick(() => {
        this.$refs.inhouseMpDataForm.resetValidation();
        this.refreshForm()//Bugfix for https://github.com/vuetifyjs/vuetify/issues/11942
      });
    },
    validate() {
      try {
        return this.$refs.inhouseMpDataForm.validate()
      } catch (e) {
        return false;
      }
    },
    updateName(v) {
      this.$nextTick(() => {
        this.name = v;
      });
    },
    updateEmail(v) {
      this.$nextTick(() => {
        this.email = v;
      });
    },
    updatePhone(v) {
      this.$nextTick(() => {
        this.phone = v;
      });
    },
    setFromCheckout() {
      setGlobalKeyValue('fromCheckout', true)
      this.fromCheckout = true;
    },
    removeFromCheckout() {
      removeGlobalKey('fromCheckout');
      this.fromCheckout = false;
    },
    isMissingAgbs() {
      if (!this.accceptedAgbs) {
        ebus.$emit('toast', 'Bitte zuerst unsere AGBs akzeptieren');
        return true;
      }
      return false;
    },

    getUserInfo() {
      let result = {
        btaste: bootstrap.getBtaste(),
        fuid: firebaseUtil.getFuid(),
        name: '' + this.name,
        email: util.sanitizeEmail(this.email),
        phone: util.sanitizePhone(this.phone),
      };
      return result;
    },

    markZvtPaymentCompleted(_this, _store, paymentAuth, haendlerbeleg) {
      console.log('markZvtPaymentCompleted');
      const now = Date.now();
      let updates = {
        authCompleted: true,
        authCompletedAt: now,
        authorisedTotal: 0 + _this.total,
        isPayPal: false,
        paid: true,
        captured: true,
        capturedAt: now,
        paymentAuth: paymentAuth,
        haendlerbeleg: haendlerbeleg
      };

      if (qconst.withPosApi) {
        updates.posConfirmedTime = 0;
      }

      let finalOrder = Object.assign(util.cloneMe(_this.order), updates);
      _store.commit('updateOrder', finalOrder);

      let order = util.cloneMe(_this.order);
      if (!order) {
        throw 'order not found for markOrderAsAuthorized';
      }
      let uniqueOrderId = order.uniqueOrderId;
      let updateOrder = {
        action: qconst.action$DocUpserter,
        collectionName: 'orders',
        updates: updates,
        subjectKey: {
          key: 'uniqueOrderId',
          value: uniqueOrderId
        },
        autoRetry: true,
      };
      xhr.xhrSend(true, updateOrder, (reply) => {
        if (reply && reply.ok) {
          console.log('single order successfully updated with paymentAuth');
          let finalOrder = Object.assign(util.cloneMe(this.order), reply);

          const checkoutItems = cloneMe(store.getters.cartItems);
          ebus.$emit('fastUpdateInventory', checkoutItems);

          _store.commit('deleteAllCartItems');
          _this.showZvtDialog = false;
          _this.logPurchase();
          _this.$ls.remove('userSelectedTargetTime');
          // ebus.$emit('showInfo', {
          //   title: 'Die Zahlung wurde erfolgreich abgeschlossen',
          //   selfClosing: true,
          //   text: ''
          // });
          console.log('sending triggerBonPrintOrder');
          ebus.$emit('postToWindowskiosk', {
            action: 'triggerBonPrintOrder',
            order: cloneMe(finalOrder),
            cb: 'cb-triggerBonPrintOrder'
          });
          setTimeout(() => {
            setGlobalKeyValue('contextPostOrder', true);
            console.log('zvt finished. going to open orderDetail for ' + uniqueOrderId)
            setTimeout(() => {
              ebus.$emit('resetKiosk');
            }, kioskResetTimeoutAfterOrder);
            _this.$router.replace({
              name: 'Bestellung',
              params: {
                uniqueOrderId: uniqueOrderId
              }
            });
          }, 700);
        } else {
          console.log('single order reply not ok for paymentAuth');
          //retry
          console.log('retry markZvtPaymentCompleted...');
          setTimeout(() => {
            _this.markZvtPaymentCompleted(_this, _store, paymentAuth, haendlerbeleg);
          }, 800);
        }
      }, (err) => {
        //retry
        let eMsg = 'retry markZvtPaymentCompleted...'
        console.log(eMsg);
        ebus.$emit('throwError', getErrorDetails(err, 'CheckoutInhouseMitOnlinePayment', eMsg));
        setTimeout(() => {
          _this.markZvtPaymentCompleted(_this, _store, paymentAuth, haendlerbeleg);
        }, 800);
      }, 15 * 1000);
    },

    _saveOrder(retryCount) {
      console.log('_saveOrder');
      if (!retryCount) {
        retryCount = 0;
      }
      let checkpoints = 0;
      try {
        store.commit('showLoading', true);
        // this.safeUnload();
        let order;
        ++checkpoints;
        order = this.generateOrder();
        ++checkpoints;

        let msg = {
          action: qconst.action$SaveNewOrder,
          order: order,
          // captchaText: '' + this.captchaInput
        };

        let timeout = qconst.withPosApi ? (60 * 1000) : (10 * 1000);
        xhr.xhrSend(true, msg, (reply) => {
          //either ok with orderId or notOk
          store.commit('showLoading', true);
          ++checkpoints;
          console.log('??? SaveNewOrder reply OK = ' + !!reply.ok);
          if (reply.ok) {
            ++checkpoints;
            this.order = reply;
            // this.currentStep = 2;

            this.waitingForZvtFreitext = '' + this.order.uniqueOrderId;
            this.terminalInstructions = '';
            this.showZvtDialog = true;
            this.zvtTimeoutId = setTimeout(() => {
              this.closeZvtDialog();
            }, 1000 * (120 + 180))
            this.initIvZvt();
            ebus.$emit('postToWindowskiosk', {
              action: 'triggerPosTerminal',
              uniqueOrderId: '' + this.order.uniqueOrderId,
              orderId: '' + this.order.orderId,
              betrag: 0 + this.total,
              trinkgeld: 0,
              cb: 'cb-postToWindowskiosk'
            });

          } else {
            store.commit('showLoading', false);
            if (reply.captchaError || reply.secTokenError) {
              ebus.$emit('forceReload');
              // this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
            } else if (reply.forceReload) {
              alert('Hinweis: Nach einer kurzen Aktualisierung der App, die automatisch durchgeführt wird,' +
                ' kannst du deine Bestellung abschließen.');
              ebus.$emit('forceReload');
            } else {
              checkpoints += 300;
              this.notifyError('Fehler bei der Verarbeitung der Bestellung', 'Bitte versuche es erneut');
              ebus.$emit('pullBuyersProfile');
              ebus.$emit('throwError', getErrorDetails('Error in save new order inhouse, checkpoints: ' + checkpoints));
            }
          }
        }, (err) => {
          store.commit('showLoading', false);
          checkpoints += 20000;
          ebus.$emit('throwError', getErrorDetails('Transport error in save new order inhouse; checkpoints: ' + checkpoints + ' retryCount: ' + retryCount + ' error:' + err.message));
          //this.notifyError('Fortschritt ' + retryCount + 1 + '/' + 5, '');

          if (!retryCount || retryCount < 2) {
            //retry
            let r = ++retryCount;
            setTimeout(() => {
              this._saveOrder(r);
            }, 2200);
          } else {
            // store.commit('showLoading', false);
            this.notifyError('Verbindungsfehler', 'Bitte versuche es direkt nochmal');
            console.log('Error Verbindungsfehler');
          }
        }, timeout);
      } catch (e) {
        store.commit('showLoading', false);
        checkpoints += 30000;
        ebus.$emit('throwError', getErrorDetails('Exception in save new order inhouse: ' + e.message + '; checkpoints: ' + checkpoints));
        console.log('!!!!! error: ' + e.message);
      }
    },

    preInit() {
      if (this.checkEnter()) {
        this.init();
      }
    },
    phoneKeydown(e) {
      util.phoneKeydown(e);
    },

    hideToolbar() {
      store.commit('hideToolbar', true);
    },
    unhideToolbar() {
      store.commit('hideToolbar', false);
    },
    clickRadio() {
      util.delayScroll('paymentRadios');
    },

    showLieferzeiten() {
      this.timesInfoDialog = true;
    },

    updateTotal() {
      this.total = 0 + roundToTwo(store.getters.payerSum) - this.totalSavedByDiscounts;
    },

    checkEnter() {
      try {
        if (
          // (!this.$ls.get('asGuest',true) && store.getters.loggedIn === false) ||
          store.getters.cartItems.length === 0
          || !store.getters.orderingEnabled
          || (store.getters.table < 1 && !store.state.orderArea)
          || !store.getters.isKiosk
        ) {
          ebus.$emit('gotoStart');
          return false;
        }
        return true;
      } catch (e) {
        console.log('Error in checkEnter...');
        ebus.$emit('gotoStart');
        return false;
      }
    },

    preselectFields() {
      // try {
      //   let fd = this.$ls.get('inhouseformData', {});
      //   this.hasFd = !util.isEmptyObject(fd);
      //   if (this.hasFd) {
      //     if (fd.name) {
      //       this.name = fd.name;
      //     }
      //     if (fd.email) {
      //       this.email = util.sanitizeEmail(fd.email);
      //     }
      //     if (fd.phone) {
      //       this.phone = util.sanitizePhone(fd.phone);
      //     }
      //     if (fd.invoiceAddress && fd.invoiceAddress.street.length > 0) {
      //       this.invoiceAddress = fd.invoiceAddress;
      //     }
      //     // if (fd.note) {
      //     //   this.note = fd.note;
      //     // }
      //   } else {
      //     // this.invoiceAddress.plz = store.state.defaultPlz; //default PLZ
      //     // this.invoiceAddress.city = store.state.defaultCity; //default City
      //   }
      //   let fbUser = firebaseUtil.getUser();
      //   if (fbUser) {
      //     if (fbUser.displayName) {
      //       this.name = fbUser.displayName;
      //     }
      //     if (fbUser.email) {
      //       this.email = fbUser.email;
      //     }
      //     if (fbUser.phoneNumber) {
      //       this.phone = fbUser.phoneNumber;
      //     }
      //   }
      //   this.resetValidation();
      // } catch (e) {
      //   ebus.$emit('throwError', getErrorDetails('error in load form: ' + e.message));
      // }
    },

    init(eventSource) {
      try {
        // alert('init eventSource '+eventSource);
        // this.currentStep = 1;
        this.consent = false;

        this.showBar = !!store.state.appContext.bar;
        this.showGoodpayGoogleWallet = enableGoodpay && !isIos() && window.PaymentRequest;//!!store.state.appContext.credit;
        this.showGoodpayAppleWallet = enableGoodpay && (isIos() || !PROD_ENV);
        // this.showWallet = !!store.state.appContext.credit;
        this.showPaypal = enablePaypal;

        this.psp = 'zvt'; // default

        // this.initTimesArray();

        //preselect time
        // this.preselectTime();


        // this.initTimesArray();
        //
        // //preselect time
        // let st = store.getters.selectedTime;
        // for (let t of this.times) {
        //     if (t.value === st.value) {
        //         this.time = t;
        //         break;
        //     }
        // }

        //init stores
        // this.stores = util.cloneMe(store.getters.stores);

        // //preslect autoModel the store from the local store
        // let lsSelectedStore = this.$ls.get('selectedStore');
        // if (lsSelectedStore) {
        //     let lss = JSON.parse(lsSelectedStore);
        //     if (lss.plz && lss.strasse) {
        //         store.getters.selectedStore = util.cloneMe(lss);
        //         this.autoModel = {
        //             displayName: lss.strasse + ', ' + lss.plz + ' ' + lss.ort,
        //             obj: lss
        //         };
        //     }
        // }

        //preselect psp
        // if (this.showBar) {
        //     this.psp = 'bar';
        // } else if (this.showGoodpayWallet) {
        //     this.psp = 'credit';
        // } else if (this.showPaypal) {
        //     this.psp = 'paypal';
        // }

        //fill name, email, phone, invoiceAddress and deliveryAddress as possible
        // if (!this.asGuest) {
        //     let user = firebaseUtil.getUser();
        //     if (user) {
        //         if (user.displayName && user.displayName.indexOf(' ') > 0) {
        //             this.name = user.displayName;
        //         }
        //         this.email = user.email;
        //         this.phone = user.phoneNumber;
        //         // //init vorname und nachname
        //         // this.vorname = user.displayName.substring(0, user.displayName.indexOf(' '));
        //         // this.nachname = user.displayName.substring(user.displayName.indexOf(' '), user.displayName.length);
        //     }
        // }

        this.preselectFields();

        // if(this.invoiceAddress.street.length === 0){
        //     //preselect company
        //     let _company = this.$ls.get('company');
        //     if (_company) {
        //         this.invoiceAddress.company = _company;
        //     }
        //
        //     let _invoiceAddress = this.$ls.get('invoiceAddress');
        //     if (_invoiceAddress) {
        //         let ia = JSON.parse(_invoiceAddress);
        //         if (ia.company) {
        //             this.invoiceAddress.company = ia.company;
        //         }
        //         if (ia.street) {
        //             this.invoiceAddress.street = ia.street
        //         }
        //         if (ia.plz) {
        //             this.invoiceAddress.plz = ia.plz
        //         }
        //         if (ia.city) {
        //             this.invoiceAddress.city = ia.city
        //         }
        //         // if (ia.etage) {
        //         //     this.invoiceAddress.etage = ia.etage
        //         // }
        //     }
        // }
        //
        // if(this.deliveryAddress.street.length === 0){
        //     let _deliveryAddress = this.$ls.get('deliveryAddress');
        //     if (_deliveryAddress) {
        //         let da = JSON.parse(_deliveryAddress);
        //         if (da.company) {
        //             this.deliveryAddress.company = da.company;
        //         }
        //         if (da.street) {
        //             this.deliveryAddress.street = da.street
        //         }
        //         if (da.plz) {
        //             this.deliveryAddress.plz = da.plz
        //         }
        //         if (da.city) {
        //             this.deliveryAddress.city = da.city
        //         }
        //         if (da.etage) {
        //             this.deliveryAddress.etage = da.etage
        //         }
        //     }
        // }


        // this.usecase = store.state.goforTakeaway ? 'inhouse' : 'delivery';

        //Only for delivery usecase
        // let _deliveryAddress = this.$ls.get('deliveryAddress');
        // if (_deliveryAddress) {
        //     let da = JSON.parse(_deliveryAddress);
        //     if (da.company) {
        //         this.deliveryAddress.company = da.company;
        //     }
        //     if (da.street) {
        //         this.deliveryAddress.street = da.street;
        //     }
        //     if (da.plz) {
        //         this.deliveryAddress.plz = da.plz;
        //     }
        //     if (da.city) {
        //         this.deliveryAddress.city = da.city;
        //     }
        //     if (da.etage) {
        //         this.deliveryAddress.etage = da.etage;
        //     }
        // }


        this.updateTotal();
        // this.updateMinOrderAmount();
        // this.updateDeliveryFee();


        // //init times array
        // let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        // let allMinutes = ['00', '15', '30', '45'];
        //
        // // let isFirstTime = true;
        //
        // //day1
        // if (store.state.day1.opened) {
        //     this.internalDaySelected = '1';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     let rNow = util.getCurrentRemoteTime();
        //     let currentHour = rNow.getHours();
        //     let currentMinutes = rNow.getMinutes();
        //     let zieltermin = util.calculateZielterminOfToday(store.getters.appconfig.takeAway.delayInMinutes);
        //
        //     console.log('???? zieltermin hours = ' + zieltermin.getHours());
        //
        //     for (let hour of relevantHours) {
        //
        //         //ignore hours before zieltermin
        //         if (hour < zieltermin.getHours()) {
        //             continue;
        //         }
        //
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //
        //         for (let minute of allMinutes) {
        //             if (hour === currentHour) {
        //
        //                 let _minute = parseInt(minute, 10);
        //
        //                 //ignore minutes before now
        //                 if (_minute <= currentMinutes) {
        //                     continue;
        //                 }
        //
        //                 //ignore minutes before zieltermin
        //                 if (_minute < zieltermin.getMinutes()) {
        //                     continue;
        //                 }
        //             }
        //             this.times1.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }
        //
        // //day2
        // if (store.state.day2.opened) {
        //     this.internalDaySelected = '2';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     for (let hour of relevantHours) {
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //         for (let minute of allMinutes) {
        //             this.times2.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }

        //the payment intent is already ready to go
      } catch (e) {
        console.log('Error: ' + e.message);
        ebus.$emit('info', 'Fehler bei der Initialisierung');
      }
    },//eof init

    preselectTime() {
      //     let st = store.getters.selectedTime;
      //     if (this.selectedAbholDatum === 'Heute') {
      //         for (let t of this.timesToday) {
      //             if (t.value === st.value) {
      //                 this.time = t;
      //                 break;
      //             }
      //         }
      //     } else {
      //         for (let t of this.timesTomorrow) {
      //             if (t.value === st.value) {
      //                 this.time = t;
      //                 break;
      //             }
      //         }
      //     }
    },

    // initTimesArray() {
    //     console.log('initTimesArray...');
    //     let appconfig = util.cloneMe(store.getters.appconfig);
    //     if (!appconfig.inhouse.openingHours['1']) {
    //         //XHR has not finished loading the appconfig yet
    //         return;
    //     }
    //     //init times array
    //
    //     this.timesToday.splice(0, this.timesToday.length);
    //     this.timesTomorrow.splice(0, this.timesTomorrow.length);
    //
    //     //takwaways either on today or tomorrow so we need to filter the hours
    //     let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    //     // let allMinutes = ['00', '15', '30', '45'];
    //     // let moreMinutes = ['00', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
    //
    //     //calculate delayInMinutes
    //     let delayInMinutes = util.calcDelayInMinutes(appconfig.inhouse.delayInMinutes, util.cloneMe(store.getters.cartItems));
    //
    //     //Init Heute timesToday
    //     // this.internalDaySelected = '1';
    //     let today = util.getDayOfWeek(new Date());
    //     let ohsToday = appconfig.inhouse.openingHours['' + today];
    //     // console.log('openedToday = '+ohsToday.opened);
    //     if (ohsToday.opened) {
    //         let relevantHours = allHours.filter((h) => {
    //             return this.allowedHours(h, ohsToday)
    //         });
    //
    //         if (relevantHours) {
    //             // let nextDay = util.getNextDay();
    //             let rNow = new Date();
    //             let currentHour = rNow.getHours();
    //             let currentMinutes = rNow.getMinutes();
    //             let earliestAbholung = util.calculateZielterminOfToday(delayInMinutes);
    //             // console.log('???? earliestAbholung utc = ' + earliestAbholung.getTime());
    //
    //             for (let hour of relevantHours) {
    //
    //                 //ignore hours before zieltermin
    //                 if (hour < earliestAbholung.getHours()) {
    //                     continue;
    //                 }
    //
    //                 let h = '' + hour;
    //                 if (hour < 10) {
    //                     h = '0' + h;
    //                 }
    //
    //                 this.generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohsToday, this.timesToday, true);
    //             }//eof of init today
    //         }
    //
    //     }
    //     if (this.timesToday.length > 0) {
    //         this.abholDatumArray[0].value = 'Heute';
    //     } else {
    //         this.abholDatumArray[0].value = 'Heute geschlossen';
    //     }
    //
    //
    //     //init Morgen timesTomorrow
    //     // this.internalDaySelected = '1';
    //     let tomorrow = util.getNextDay();
    //     let ohsTomorrow = appconfig.inhouse.openingHours['' + tomorrow];
    //     if (ohsTomorrow.opened) {
    //         let relevantHours2 = allHours.filter((h) => {
    //             return this.allowedHours(h, ohsTomorrow)
    //         });
    //         // let nextDay = util.getNextDay();
    //         // let rNow = new Date();
    //         // let currentHour = rNow.getHours();
    //         // let currentMinutes = rNow.getMinutes();
    //         // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
    //         if (relevantHours2) {
    //             for (let hour of relevantHours2) {
    //
    //                 //ignore hours before zieltermin
    //                 // if (hour < zieltermin.getHours()) {
    //                 //     continue;
    //                 // }
    //
    //                 let h = '' + hour;
    //                 if (hour < 10) {
    //                     h = '0' + h;
    //                 }
    //
    //                 this.generateMinutes(delayInMinutes, h, hour, null, null, ohsTomorrow, this.timesTomorrow, false);
    //
    //
    //             }//eof of init tomorrow
    //         }
    //
    //
    //     }
    //     if (this.timesTomorrow.length > 0) {
    //         this.abholDatumArray[1].value = 'Morgen';
    //     } else {
    //         this.abholDatumArray[1].value = 'Morgen geschlossen';
    //     }
    //
    //
    //     // this.preselectDay1();
    // },

    // generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohs, timesArray, forToday) {
    //     try {
    //         let lessMinutes = ['00', '15', '30', '45'];
    //         let allMinutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
    //         for (let minute of allMinutes) {
    //             let _minute = parseInt(minute, 10);
    //
    //             let utcValue;
    //             if (forToday) {
    //                 utcValue = new Date();
    //             } else {
    //                 utcValue = util.addDays(util.getCurrentRemoteTime(), 1);
    //             }
    //             // console.log('checkout utc = ' + nd.getTime());
    //             // console.log('checkout utc date = ' + nd);
    //             // console.log('checkout utc locale = ' + nd.toLocaleString());
    //             utcValue.setHours(hour);
    //             utcValue.setMinutes(_minute);
    //             let diff2Now = utcValue.getTime() - Date.now();
    //             let isWithin60Minutes = diff2Now < (1000 * 60 * 60);
    //             if (isWithin60Minutes || forToday) {
    //                 //ignore times if delayInMinutes from now is too small
    //                 if (diff2Now < (delayInMinutes * 60 * 1000)) {
    //                     continue;
    //                 }
    //             }
    //
    //             if (forToday) {
    //                 if (hour === currentHour) {
    //                     //ignore minutes before now
    //                     if (_minute <= currentMinutes) {
    //                         continue;
    //                     }
    //                 }
    //             }
    //
    //             if (!isWithin60Minutes) {
    //                 if (!lessMinutes.includes(minute)) {
    //                     continue; //less minutes for everything later than 60 minutes
    //                 }
    //             }
    //
    //             if (hour === ohs.a.fromHour) {
    //                 if (!(ohs.a.fromMinute <= _minute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === ohs.a.tillHour) {
    //                 if (!(_minute <= ohs.a.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === ohs.b.fromHour) {
    //                 if (!(ohs.b.fromMinute <= _minute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === ohs.b.tillHour) {
    //                 if (!(_minute <= ohs.b.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //
    //             timesArray.push({
    //                 value: h + ':' + minute,
    //                 display: 'ca. ' + h + ':' + minute + ' Uhr',
    //                 utc: utcValue.getTime()
    //             });
    //         }
    //     } catch (e) {
    //         ebus.$emit('throwError', getErrorDetails('Exception in generateMinutes: ' + e.message);
    //     }
    // },

    // initTimesArray() {
    //     //init times array
    //     //takwaways is always on the next day so we don't neet to filter the times
    //     let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    //     let allMinutes = ['00', '30'];
    //
    //     // let isFirstTime = true;
    //
    //     // this.internalDaySelected = '1';
    //     let relevantHours = allHours.filter(this.allowedHours);
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //     // let currentMinutes = rNow.getMinutes();
    //     // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
    //
    //     // console.log('???? zieltermin hours = ' + zieltermin.getHours());
    //
    //     for (let hour of relevantHours) {
    //
    //         //ignore hours before zieltermin
    //         // if (hour < zieltermin.getHours()) {
    //         //     continue;
    //         // }
    //
    //         let h = '' + hour;
    //         if (hour < 10) {
    //             h = '0' + h;
    //         }
    //
    //         for (let minute of allMinutes) {
    //             let minNum = 0;
    //             if (minute !== '00') {
    //                 minNum = 30;
    //             }
    //
    //             if (hour === relevantDay.a.fromHour) {
    //                 if (!(relevantDay.a.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.a.tillHour) {
    //                 if (!(minNum <= relevantDay.a.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.fromHour) {
    //                 if (!(relevantDay.b.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.tillHour) {
    //                 if (!(minNum <= relevantDay.b.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //
    //             // if (hour === currentHour) {
    //             //
    //             //     let _minute = parseInt(minute, 10);
    //             //
    //             //     //ignore minutes before now
    //             //     if (_minute <= currentMinutes) {
    //             //         continue;
    //             //     }
    //             //
    //             //     //ignore minutes before zieltermin
    //             //     if (_minute < zieltermin.getMinutes()) {
    //             //         continue;
    //             //     }
    //             // }
    //
    //             let nd = util.addDays(util.getCurrentRemoteTime(), 1);
    //             // console.log('checkout utc = ' + nd.getTime());
    //             // console.log('checkout utc date = ' + nd);
    //             // console.log('checkout utc locale = ' + nd.toLocaleString());
    //             nd.setHours(hour);
    //             nd.setMinutes(minNum);
    //
    //
    //             this.times.push({
    //                 value: h + ':' + minute,
    //                 display: h + ':' + minute + ' Uhr',
    //                 utc: nd.getTime()
    //             });
    //             // if (isFirstTime) {
    //             //     this.time = h + ':' + minute;
    //             //     isFirstTime = false;
    //             // }
    //         }
    //     }
    //     // this.preselectDay1();
    // },

    // preselectDay1() {
    //     //preselect first option
    //     if (this.times1.length > 0) {
    //         this.time = this.times1[0].value;
    //     }
    // },

    // preselectDay2() {
    //     //preselect first option
    //     if (this.times2.length > 0) {
    //         this.time = this.times2[0].value;
    //     }
    // },

    // allowedHours(h, dayOh) {
    //     // let rNow = Date.now();
    //     // let currentHour = rNow.getHours();
    //
    //     // if (isToday) {
    //     //     //ignore hours before now
    //     //     if (h < currentHour) {
    //     //         return false;
    //     //     }
    //     // }
    //     //check period a
    //     let matchesA = dayOh.a.fromHour <= h && h <= dayOh.a.tillHour;
    //     if (matchesA) {
    //         return true;
    //     }
    //     if (dayOh.b.fromHour !== dayOh.b.tillHour) {
    //         return dayOh.b.fromHour <= h && h <= dayOh.b.tillHour;
    //     }
    //     return false;
    // },

    selectMethod(pMethod) {
      this.selectedAliasId = pMethod.aliasId;
      console.log('??? selected aliasId=' + this.selectedAliasId);
      // if (pMethod.aliasId !== this.goodpayTxIsForAliasId) {
      //   this.initGoodpayCreditTx();
      // }
    },

    gotoSummary() {
      this.$router.push({name: 'Korb'});
    },

    gotoAccount() {
      this.$router.push({name: 'Account'});
    },

    changeFiliale() {
      ebus.$emit('triggerFilialeDialog')
    },

    gotoPms(onlyShow) {
      // if (!onlyShow) {
      this.setFromCheckout();
      setGlobalKeyValue('pmForCheckout', true);
      // }
      store.commit('secondSelectedDialog', '');
      store.commit('selectedDialog', 'PaymentMethods');
      store.commit('showDialogContainer', true);
      ebus.$emit('addCardForCheckout');
      // this.$router.push({
      //   name: 'Zahlungsmittel'
      // });
    },


    //Überprüfe deine Daten
    finishStep1() {

      this.$nextTick(() => {
        if (!this.validate() || !this.step1Ok) {
          this.initialTry = true;
          return;
        }

        checkoutUtil.reset();
        this.email = util.removeSpaces(this.email);

        this.saveForm();

        //double check
        // let err = this.step1Ok();
        // if () {
        //     return;
        // }

        // if (!store.state.user.name || store.state.user.name.length < 3) {
        //     ebus.$emit('showInfo', {title: 'Gib deinen Namen ein, um fortzufahren'});
        //     return;
        // }

        if (store.getters.cartSum === 0) {
          this.$router.push({name: 'Korb'});
          return;
        }

        // //Prüfe den Mindestbestellwert
        // if (store.getters.cartSum < store.getters.appconfig.inhouse.minOrderAmount) {
        //     // if (store.getters.cartSum < store.getters.selectedStore.minOrderAmount) {
        //     // if (store.getters.cartSum < this.minOrderAmount) {
        //     //     if (this.usecase === 'delivery') {
        //     this.$router.push({name: 'Korb'});
        //     ebus.$emit('showInfo', {
        //         title: 'Bitte beachte den Mindestbestellwert von '
        //             + util.getLocalPrice(store.getters.appconfig.inhouse.minOrderAmount)
        //     });
        //     return;
        //     // }
        // }

        //Prüfe Verfügbarkeit aller Waren
        // let itemsNotAvailable = [];
        // for (let itm of store.getters.cartItems) {
        //     if (itm.couponCode) {
        //         continue;
        //     }
        //     if (!plausi.itemAvailableTomorrow(itm)) {
        //         itemsNotAvailable.push(itm);
        //     }
        // }
        // if (itemsNotAvailable.length > 0) {
        //     let names = itemsNotAvailable.map(itm => itm.nameToDisplay);
        //     // let filialeName = store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
        //     ebus.$emit('showInfo', {
        //         title: 'Folgende Waren sind morgen nicht verfügbar: ' + this.$options.filters.stringList(names),
        //         text: 'Bitte entfernen Sie nicht verfügbare Waren aus dem Korb.'
        //     });
        //     this.$router.push({name: 'Korb'});
        //     return;
        // }

        this.updateTotal();

        // if (this.asGuest) {
        // store.commit('showLoading', true);
        // this.safeUnload();
        // this.currentStep = 2;

        //only for iframe
        // if (iframe.isInIframe()) {
        //     util.jumpToTop();
        // } else {
        // }

        util.closeSoftKeyBoard();

        //first step before starting any payment is to store the order
        this._saveOrder(0);
      });
    },

    safeUnload(seconds, self) {
      try {
        if (!self) {
          self = this;
        }
        if (isNaN(seconds)) {
          seconds = 6;
        }
        let now = Date.now();
        let millis = seconds * 1000;
        let targetTime = now + millis;
        self.unloadTargetTime = targetTime
        store.commit('showLoading', true);
        setTimeout(() => {
          let diff = Date.now() - self.unloadTargetTime;
          if (diff > -600 && diff < 600) {
            store.commit('showLoading', false);
          }
        }, millis);
      } catch (e) {
        console.log('error in safeUnload: ' + e.message);
      }
    },

    stopLoading(self) {
      if (!self) {
        self = this;
      }
      self.loading = false;
      store.commit('showLoading', false);
      this.unloadTargetTime = 0;
    },

    reloadCaptcha() {
      // // store.commit('showLoading', true);
      // this.generateCaptcha((responseOrFalse) => {
      //     if (responseOrFalse) {
      //         this.renderCaptcha(responseOrFalse);
      //     }
      //     // store.commit('showLoading', false);
      // });
    },

    async renderCaptcha(arrayBuffer) {
      // try {
      //     // Obtain a blob: URL for the image data.
      //     let arrayBufferView = new Uint8Array(arrayBuffer);
      //     let blob = new Blob([arrayBufferView], {type: "image/jpeg"});
      //     let urlCreator = window.URL || window.webkitURL;
      //     let imageUrl = urlCreator.createObjectURL(blob);
      //     let img = document.getElementById("captchaUmage");
      //     this.$nextTick(() => {
      //         img.src = imageUrl;
      //     });
      //
      //     // let img = new Image();
      //     // // let response = base64Buffer;
      //     // // let binary = '';
      //     // // for (let i = 0; i < response.length; i++) {
      //     // //     binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
      //     // // }
      //     //
      //     // // img.src = 'data:image/jpeg;base64,' + btoa(binary);
      //     // img.src = 'data:image/jpeg;base64,' + base64Buffer;
      //     // let canvas = document.getElementById('captchaUmage');
      //     //
      //     // let context = canvas.getContext('2d');
      //     // this.$nextTick(() => {
      //     //     context.drawImage(img, 0, 0);
      //     // });
      // } catch (e) {
      //     ebus.$emit('throwError', getErrorDetails('error in drawCaptcha: ' + e.message);
      //     console.log('error in drawCaptcha: ' + e.message);
      // }
    },

    generateCaptcha(cb) {
      // xhr.xhrGetImage('xhr/captcha/generate',
      //     // {
      //     //     'Accept': '*/*'
      //     // },
      //     (reponseData) => {
      //         if (cb) {
      //             cb(reponseData);
      //         }
      //     },
      //     (err) => {
      //         if (cb) {
      //             cb(false);
      //         }
      //     }
      // );
    },

    saveForm() {
      try {
        let _fd = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          // note: this.note,
        };
        let fd = util.cloneMe(_fd);
        let ia = this.invoiceAddress;
        if (ia && ia.street && ia.street.length > 0) {
          fd.invoiceAddress = util.cloneMe(ia);
        }
        let da = this.deliveryAddress;
        if (da && da.street && da.street.length > 0) {
          fd.deliveryAddress = util.cloneMe(da);
        }
        util.sanitizeProps(fd);
        util.removeEmptyProps(fd);
        let san = util.sanitizePhone(fd.phone);
        if (san) {
          fd.phone = san;
        }
        let sanEmail = util.sanitizeEmail(fd.email);
        if (sanEmail) {
          fd.email = sanEmail;
        }
        if (fd.name || fd.phone) {
          this.$ls.set('inhouseformData', fd);
        }

        let user = {
          name: fd.name,
          email: fd.email,
          phone: fd.phone,
        };
        util.removeEmptyProps(user);
        store.commit('user', user);

      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in saveForm: ' + e.message));
      }
    },

    //Abholzeit
    // finishStep3() {
    //
    //     console.log('timeSelected: ' + this.time);
    //
    //     // this.displayPickupDate = util.displayPickupDate(pickupDate);
    //     // this.displayPickupDate = util.alternativeDisplayPickupDate(this.daySelected, this.time);
    //
    //     this.currentStep = 4;
    //
    //     if (this.psp !== 'bar') {
    //         setTimeout(() => {
    //             util.delayScroll('paymentRadios');
    //         }, 900);
    //     }
    // },

    // finishStep3() {
    //     if (this.consentA && this.consentB) {
    //         this.currentStep = 4;
    //     }
    // },

    checkMobilnummer() {
      if (!isMobileOk(this.phone)) {
        // let restName = store.state.restaurantData.restaurantName;
        if (this.initialTry) {
          ebus.$emit('showInfo', {
            title: 'Mobilnummer notwendig',
            text: 'Durch Angabe deiner Mobilnummer können wir nach deiner Bestellung ' +
              +'Kontakt zu dir aufnehmen'
          });
        }
        return false;
      }
      return true;
    },

    // allowedHours(h) {
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let relevantDay = store.state['day' + this.internalDaySelected];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //
    //     // if (this.internalDaySelected === '1') {
    //     // //ignore hours before now
    //     // if (h < currentHour) {
    //     //     return false;
    //     // }
    //     // }
    //
    //     //check period a
    //     let matchesA = relevantDay.a.fromHour <= h && h <= relevantDay.a.tillHour;
    //     if (matchesA) {
    //         return true;
    //     }
    //
    //     //check period b
    //     if (relevantDay.b.fromHour !== relevantDay.b.tillHour) {
    //         return relevantDay.b.fromHour <= h && h <= relevantDay.b.tillHour;
    //     }
    //     return false;
    // },

    // allowedMinutes(m) {
    //     if (m % 30 === 0) {
    //         return true;
    //     }
    //
    //     return false;
    // },

    // creditCollectPaymentMethod() {
    //     goodpayUtil.createCardElement();
    //     goodpayUtil.cardElement.mount('#card-element');
    //
    //     setTimeout(() => {
    //         this.initCreditSubmitButton();
    //     }, 600);//the mount takes a view milliseconds
    // },

    // initCreditSubmitButton() {
    //     const cardholderName = document.getElementById('cardholder-name');
    //     const cardButton = document.getElementById('card-button');
    //
    //     //always provide the customer’s name, email, billing address,
    //     // and shipping address (if available) to the credit.handleCardPayment call.
    //     cardButton.addEventListener('click', async (ev) => {
    //         //Note that credit.handleCardPayment may take several seconds to complete. During that time,
    //         // you should disable your form from being resubmitted and show a waiting indicator like a spinner.
    //         let _billing_details = {
    //             name: store.state.user.name,
    //             email: store.state.user.email
    //         };
    //         if (store.state.user.mobile) {
    //             _billing_details.mobile = store.state.user.mobile;
    //         }
    //
    //         const {paymentIntent, error} = await goodpayUtil.credit.handleCardPayment(
    //             this.clientSecret, goodpayUtil.cardElement, {
    //                 payment_method_data: {
    //                     billing_details: _billing_details
    //                 },
    //                 save_payment_method: true,
    //                 receipt_email: store.state.user.email
    //             }
    //         );
    //
    //         if (error) {
    //             // Display error.message in your UI.
    //             console.log('Payment error: ' + JSON.stringify(error));
    //         } else {
    //             // The payment has succeeded. Display a success message.
    //             console.log('Payment succeeded');
    //         }
    //     });
    // },

    doOrder() {
      if (!this.psp || this.psp === 'none') {
        return;
      }
      if (this.wait) {
        return
      }
      this.wait = true;
      setTimeout(() => this.wait = false, 2000);

      removeGlobalKey('chooseCustomercard');

      this.showSubmitButton = false;

      if (this.psp === 'credit') {
        store.commit('showLoading', true);
        //enable when using credit
        this.createCreditPaymentIntent();
      } else if (this.psp === 'paypal') {
        // store.commit('showLoading', true);
        // this.createGoodpayPaymentIntent();
        //PayPal has its own Button
      } else if (this.psp === 'customerCard') {
        // this.submitOrderWithCustomerCard(this, store);
        // store.commit('showLoading', true);
        // this.createCreditPaymentIntent();
        //PayPal has its own Button
      } else
        // if (this.checkMobilnummer())
      {
        //Barzahlung
        this.saveOrder(false);
      }
    },

    createCreditPaymentIntent() {
      //
    },

    logPurchase() {
      // let param = {
      //     currency: 'EUR',
      //     value: this.total,
      //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems)),
      //     usecase: this.usecase
      // };
      // for (let itm of store.getters.cartItems) {
      //     let isCoupon = 'nameToDisplay' in itm;
      //     if (isCoupon) {
      //         param.coupon = itm.nameToDisplay;
      //         break
      //     }
      // }
      // firebaseUtil.gevent('purchase', param);
    },


    // updateMinOrderAmount() {
    //     if (store.getters.selectedStore.minOrderAmount) {
    //         this.minOrderAmount = store.getters.selectedStore.minOrderAmount;
    //         this.fee = store.getters.selectedStore.fee;
    //     }
    // },

    // updateDeliveryFee() {
    //     this.deliveryFee = 0;
    //     this.minOrderAmount = 0;
    //     for (let area of appconfig.deliveryAreas) {
    //         if (area.plz === this.deliveryAddress.plz) {
    //             this.deliveryFee = area.fee;
    //             this.minOrderAmount = area.minOrderAmount;
    //             console.log('updateDeliveryFee deliveryFee = ' + area.fee);
    //             console.log('updateDeliveryFee minOrderAmount = ' + area.minOrderAmount);
    //             return true;
    //         }
    //     }
    //     return false;
    // },

    generateOrder() {
      try {
        let order = {
          clientId: '' + this.$ls.get('clientId'),
          lastMenuUpdate: this.$ls.get('lastMenuUpdate'),
          onlinePay: true,
          directPay: true,
          authCompleted: false,
          isKiosk: true,
          psp: store.getters.isAndroidKiosk ? 'softpos' : 'zvt',
          // simulateTransportError: false, // only to simulate transport error,
          asGuest: !!this.asGuest,
          type: 'selfOrder',
          fuid: (firebaseUtil.getFuid() ? firebaseUtil.getFuid() : null),
          btaste: bootstrap.getBtaste(),
          domain: window.location.hostname,
          channel: 'on-the-go',
          usecase: this.usecase,
          selfServiceEnabled: false,
          // restaurantId: store.getters.restId,
          createdAt: Date.now(),
          table: 0 + store.getters.table,
          //Note: delayInMinutes is irrelevant for pre-orders (asap === false)
          // delayInMinutes: store.getters.delayInMinutes,
          // expectedDelayInMinutes: store.getters.delayInMinutes,
          orderData: util.cloneMe(store.getters.cartItems),
          appliedDiscounts: util.cloneMe(store.getters.appliedDiscounts),
          // company: '' + this.company,
          // userInfo: util.cloneMe(store.state.user),
          // pickupDate: util.cloneMe(this.pickupDate),
          targetTime: Date.now() + (5 * 1000),
          requiresPickupNotification: false,// !!this.selfServiceEnabled,
          abholAdresse: '' + this.abholadresse,
          // onlinePay: this.psp !== 'bar' && this.psp !== 'beiAbholung' && this.psp !== '',
          paymentInfo: {
            // psp: '' + this.psp,
            amount: 0 + this.total,
          },
          paymentAuth: {},
          note: '',
          // invoiceAddress: {
          //   company: '' + this.invoiceAddress.company.trim(),
          //   street: '' + this.invoiceAddress.street.trim(),
          //   plz: this.invoiceAddress.plz,
          //   city: '' + this.invoiceAddress.city.trim(),
          //   // etage: '' + this.deliveryAddress.etage.trim(),
          // }
          // deliveryAddress: {
          //     company: '' + this.deliveryAddress.company.trim(),
          //     street: '' + this.deliveryAddress.street.trim(),
          //     plz: '' + this.deliveryAddress.plz.trim(),
          //     city: '' + this.deliveryAddress.city.trim(),
          //     etage: '' + this.deliveryAddress.etage.trim(),
          // }
        };

        let userSelectedTargetTime = this.$ls.get('userSelectedTargetTime');
        if (userSelectedTargetTime) {
          order.ankunftszeitDate = userSelectedTargetTime // entspricht dem model pickupDate
          order.targetTime = userSelectedTargetTime.utc;
        }

        if (qconst.withPosApi) {
          order.posConfirmedTime = 0;
        }

        if (this.isInvoiceAddressVisible) {
          let invoiceAddress = {
            company: '' + this.invoiceAddress.company.trim(),
            street: '' + this.invoiceAddress.street.trim(),
            plz: this.invoiceAddress.plz,
            city: '' + this.invoiceAddress.city.trim(),
            // etage: '' + this.deliveryAddress.etage.trim(),
          }
          order.invoiceAddress = invoiceAddress;
        }

        // let bbnUser = store.getters.bbnUser;
        // let primaryCardId = bbnUser.primaryCardId;
        // if (primaryCardId && store.getters.loggedIn) {
        //   let card = store.getters.cards.find(c => c.rfid === primaryCardId);
        //   let bbnUser = this.$ls.get('bbnUser');
        //   if (card) {
        //     let orderExtend = {
        //       card: card,
        //       cardId: card.id,
        //     };
        //     Object.assign(order, orderExtend);
        //   }
        //   if (bbnUser) {
        //     let orderExtend = {
        //       userId: bbnUser.id,
        //       userToken: bbnUser.token,
        //     };
        //     Object.assign(order, orderExtend);
        //   }
        // }

        let pushToken = this.$ls.get('pushToken');
        if (pushToken) {
          order.pushToken = pushToken;
        }

        if (store.state.orderArea) {
          order.orderArea = '' + store.state.orderArea;
        }

        if (store.getters.enableStempel) {
          order.collectStempel = true;
          order.stempelType = store.getters.stempelType;
        }
        if (this.note) {
          order.note = '' + this.note;
        }

        order.userInfo = this.getUserInfo();

        // if (!this.sameAsInvoiceAddress) {
        //   order.deliveryAddress = {
        //     company: '' + this.deliveryAddress.company,
        //     street: '' + this.deliveryAddress.street,
        //     plz: this.deliveryAddress.plz,
        //     city: '' + this.deliveryAddress.city,
        //     etage: '' + this.deliveryAddress.etage,
        //   };
        // }//else we only submit the invoiceAddress

        util.sanitizeProps(order);

        //add app string
        // if (breakpoints.getCurrentDevice() === 'xs') {
        //     order.app = 'LIEFERMAXX Mobile App'
        // } else {
        //     order.app = 'LIEFERMAXX App'
        // }

        //add operating system
        try {
          order.userAgentData = window.navigator.userAgentData;
        } catch (e) {

        }

        // if (this.onlinePay) {
        //     // order.orderNumber = this.orderNumber;
        //     // order.uniqueOrderId = this.uniqueOrderId;
        //
        //     order.paymentInfo.psp = 'credit';
        //     // order.paymentInfo.paymentIntentId = this.paymentIntentId;
        //     // order.paymentInfo.aliasId = this.selectedAliasId;
        // }
        // if (this.usecase === 'delivery') {
        //     if (this.deliveryAddress.etage.length > 0) {
        //         order.deliveryAddress.etage = this.deliveryAddress.etage;
        //     }
        order.paymentInfo.itemsTotal = 0 + store.getters.cartSum;
        // order.paymentInfo.deliveryFee = 0;// + store.state.deliveryFee;
        //     // let fee = null;
        //     // for (let area of store.getters.appconfig.deliveryAreas) {
        //     //     if (area.plz === order.deliveryAddress.plz) {
        //     //         fee = area.fee;
        //     //         break;
        //     //     }
        //     // }
        //     // if (fee === null) {
        //     //     //error
        //     //     this.notifyError('Fehler bei den Lieferkosten');
        //     //     return null;
        //     // }
        //     // order.paymentInfo.amount = this.total;
        // } else {
        // order.pickupStore = util.cloneMe(store.getters.selectedStore);
        // delete order.pickupStore.openingHours;
        // order.storeId = '' + store.getters.selectedStore.filialnummer;
        // }
        return util.cloneAndRemoveAllDisplayKeys(order, ['delay']);
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateOrder: ' + e.message));
        return null;
      }
    },

    notifyError(text, err) {
      console.log('error ' + text + ' ' + err);
      ebus.$emit('info', 'Fehler! ' + text + ' ' + (err || ''));
      this.showZvtDialog = false;
      store.commit('showLoading', false);
      clearTheInterval(this.ivZvt);
    },

    // notifyInfo(text, err) {
    //     this.$notify({
    //         type: 'info',
    //         title: text,
    //         text: err || ''
    //     });
    // },

    // focusNextField(nextFieldIndex) {
    //   const fields = ['email', 'phone', 'note'];
    //   const nextField = this.$refs[fields[nextFieldIndex - 1]];
    //
    //   if (nextField) {
    //     nextField.focus();
    //   }
    // },
  }
}

</script>

<style lang="scss" scoped>
@import '../styles/base';
@import '../styles/forms';

.highScreen {
  .onlyForHighScreens {
    height: 12vh;
  }
}

.page {
  /*To debug textfield background*/
  //background-color: $color-secondary;

  select {
    -moz-appearance: menulist !important;
    -webkit-appearance: menulist !important;
  }
}


.datefields {
  width: 70%;
  min-width: 250px;
  max-width: 350px;
}

.termin {
  margin: 8px 0 8px 8px;
}


.actions {

  td {
    text-align: left;
    padding: 1.5%;
  }
}

.bestelldaten {
  /*<!--background-color: $color-darkblue;-->*/

  tr {
    td:first-child {
      color: rgba(black, 0.7)
    }

    td:last-child {
      padding-left: 15px;
      /*color: black;*/
    }

  }

}

/*.vvd {*/
/*    background-color: rgba(white,0.7);*/
/*}*/


.ccard {
  margin-right: 16px;
  background: none;
  color: $font-color;
  //border-left: 6px solid $accent;
  //border-radius: $box-border-radius;
  padding: 8px;
  //@include material-shadow(1);

  /*<!--&:hover {-->*/
  /*<!--    @include material-shadow(2);-->*/
  /*<!--}-->*/

  .expLabel {
    font-size: smaller;
  }
}

/*.page ::v-deep .v-stepper__content{*/
/*    margin-left: 33px;*/
/*}*/

</style>
